// Admin page: one tab per management area. The active tab is kept in the
// `?tab=` search param so a tab can be linked to (and survives a reload).
// Add a new area by adding a <Tab> here.

import { Container, Tabs, Tab } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import AccountsTab from "./admin/AccountsTab";
import RecipesTab from "./admin/RecipesTab";

const TABS = ["accounts", "recipes"] as const;
type TabKey = (typeof TABS)[number];

function AdminPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get("tab");
  const active: TabKey = (TABS as readonly string[]).includes(requested ?? "") ? (requested as TabKey) : "accounts";

  return (
    <Container className="p-4">
      <h1>Admin</h1>
      <Tabs
        id="admin-tabs"
        activeKey={active}
        onSelect={(key) => setSearchParams(key && key !== "accounts" ? { tab: key } : {})}
        className="mb-3"
        mountOnEnter
        unmountOnExit
      >
        <Tab eventKey="accounts" title="Accounts">
          <AccountsTab />
        </Tab>
        <Tab eventKey="recipes" title="Recipes">
          <RecipesTab />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default AdminPage;
